import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import AuthenticationProvider from "./components/Authentication.context";
import envConfig from "./helpers/envconfig.helper";

ReactDOM.render(
    <AuthenticationProvider
    auth0={{
      authDomain: envConfig.AUTH0_DOMAIN || "",
      clientId: envConfig.AUTH0_CLIENT_ID || "",
      baseUrl: window.origin,
      audience: envConfig.AUTH0_AUDIENCE || ""
    }}
  >
    <App />
  </AuthenticationProvider>,
  document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
